import { ChangeEvent, useEffect, useRef, useState } from 'react'

import { Checkbox, Flex, Text, Tooltip } from '@chakra-ui/react'

import { OptionI } from '@/utils/forms/optionBuilders'

interface MultiSelectCheckboxIProps {
  isChecked: boolean
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  option: OptionI
}

export const MultiSelectCheckbox = ({
  isChecked,
  onChange,
  option,
}: MultiSelectCheckboxIProps) => {
  const ref = useRef(null)
  const [isOverflown, setIsOverflown] = useState(false)
  useEffect(() => {
    const element = ref.current!
    setIsOverflown(
      element
        ? element?.offsetWidth < element?.scrollWidth ||
            element?.offsetHeight < element?.scrollHeight
        : false
    )
  }, [])
  return (
    <Tooltip
      isDisabled={!isOverflown}
      label={option.label ?? 'Unknown Option'}
      openDelay={500}
      shouldWrapChildren
    >
      <Flex alignItems='center' dir='row' gap='10px' mb='10px'>
        <Checkbox isChecked={isChecked} onChange={onChange}>
          <Text fontSize='14px' fontWeight='500' noOfLines={2} ref={ref}>
            {option.label ?? 'Unknown Option'}
          </Text>
        </Checkbox>
      </Flex>
    </Tooltip>
  )
}
